import { useState } from 'react';
import { NewsletterConfig } from '@/lib/themeConfig';
import { SaveButton } from './GeneralSection';
import ImageUploader from '../ImageUploader';

interface Props { data: NewsletterConfig; onChange: (data: NewsletterConfig) => void; }

export default function NewsletterSection({ data, onChange }: Props) {
  const [local, setLocal] = useState<NewsletterConfig>(data);
  const [saved, setSaved] = useState(false);
  const u = (key: keyof NewsletterConfig, val: string) => setLocal(p => ({ ...p, [key]: val }));
  const handleSave = () => { onChange(local); setSaved(true); setTimeout(() => setSaved(false), 2000); };
  return (
    <div className="max-w-2xl space-y-6">
      <div className="bg-white rounded-2xl p-6 space-y-4">
        <h2 className="text-sm font-semibold text-stone-700 border-b border-stone-100 pb-3">Bülten / CTA Alanı</h2>
        <div><label className="block text-xs font-medium text-stone-600 mb-1.5">Rozet</label><input type="text" value={local.badge} onChange={e => u('badge', e.target.value)} className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all" /></div>
        <div><label className="block text-xs font-medium text-stone-600 mb-1.5">Başlık</label><input type="text" value={local.title} onChange={e => u('title', e.target.value)} className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all" /></div>
        <div><label className="block text-xs font-medium text-stone-600 mb-1.5">Açıklama</label><textarea value={local.description} onChange={e => u('description', e.target.value)} rows={2} className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all resize-none" /></div>
        <div><label className="block text-xs font-medium text-stone-600 mb-1.5">Buton Metni</label><input type="text" value={local.cta_text} onChange={e => u('cta_text', e.target.value)} className="w-full px-4 py-2.5 text-sm bg-stone-50 rounded-xl border border-stone-200 focus:border-amber-500 focus:outline-none transition-all" /></div>
        <ImageUploader
          label="Arka Plan Görseli"
          value={local.background_image}
          onChange={val => u('background_image', val)}
          previewHeight="h-32"
          hint="Önerilen boyut: 1920×600px"
        />
      </div>
      <SaveButton saved={saved} onSave={handleSave} />
    </div>
  );
}
